import React from "react";
import { createStyles, Box, Image } from "@mantine/core";

import PlantoryLogoWhite from "../assets/plantory_logo_white.png";
import PlantoryLogoBlack from "../assets/plantory_logo_black.png";

function AppLogo({ variant = 'white', ...otherProps }) {
  const { classes } = useStyles();
  const logoSrc = variant === 'black' ? PlantoryLogoBlack : PlantoryLogoWhite;

  return (
    <Box className={classes.container} {...otherProps}>
      <Image width={200} src={logoSrc} alt='Plantory Logo' />
    </Box>
  );
}

export default AppLogo;

const useStyles = createStyles({
  container: {},
});
